import { render } from "./Accessibility.vue?vue&type=template&id=50f2f5d2"
import script from "./Accessibility.vue?vue&type=script&lang=js"
export * from "./Accessibility.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__